<template>
  <div class="container pb-5">
    <div class="card mt-5">
      <center>
        <img
          class="febos-main-logo"
          src="https://archivos.febos.io/publico/logos/escritoriodigital_logo_horizontal.png"
          />
      </center>
      <div class="card-body">
        <div class="text-center mb-5">
          <h3>Verificación de documento</h3>
          <h3
            class="text-danger"
            v-if="approvalDetails
            && approvalDetails.ejecucion
            // eslint-disable-next-line max-len
            && estadosOcultarDocumento.includes(approvalDetails.ejecucion.aprobaciones_ejecucion_estado_id)
            "
          >
            {{
              approvalDetails.ejecucion.aprobaciones_ejecucion_estado_id == 6 ? 'ANULADO' :
              approvalDetails.ejecucion.aprobaciones_ejecucion_estado_id == 5 ? 'RECHAZADO' :
              approvalDetails.ejecucion.aprobaciones_ejecucion_estado_id == 1 ? 'DESESTIMADO' :
                'OTRO'
            }}

          </h3>
        </div>
        <div v-if="loading">
          <center>
            <div>
              <img src="https://portal.febos.cl/desarrollo/assets/img/logos/FEBOS_LOADER.svg"
                   width="30"/>
            </div>
            <div>
              Estamos buscando el documento, danos unos segundos
            </div>
          </center>
        </div>
        <div v-if="!loading && !approvalDetails">
          <div style="font-size: 110%">
            <center>
              <b-icon icon="x-circle" class="text-danger"/>
              No encontramos información del documento consultado
            </center>
          </div>
        </div>
        <div v-if="!loading">
          <h4 class="mb-4">
            <b-icon icon="info-circle"/>
            Información General
          </h4>
          <div v-if="dte">
            <DTE :formatNumber="formatNumber" :dte="dte"/>
          </div>
          <div v-else-if="dnt">
            <AllTypes :formatNumber="formatNumber" :dnt="dnt"/>
          </div>
          <div v-else>
            <NoDnt :formatNumber="formatNumber" :data="approvalDetails.ejecucion"/>
          </div>
        </div>
        <div v-if="!loading">
          <hr>
          <Approvals
            v-if="approvalsMustBeShown"
            :approvals="approvalDetails.aprobaciones"
          />
          <DigitalSignatures
            v-if="approvalDetails
            && approvalDetails.ejecucion
            // eslint-disable-next-line max-len
            && !estadosOcultarDocumento.includes(approvalDetails.ejecucion.aprobaciones_ejecucion_estado_id)
            && approvalDetails.firmas"
            :signatures="approvalDetails.firmas"
            :url="approvalDetails.url"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import DTE from './DTE';
import NoDnt from './NoDnt';
import AllTypes from './AllTypes';
import Approvals from './Approvals';
import DigitalSignatures from './DigitalSignatures';

import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';

export default {
  name: 'VerificacionQrAprobaciones',
  mixins: [PersonalizacionMixin],
  components: {
    DTE, AllTypes, Approvals, DigitalSignatures, NoDnt
  },
  data() {
    return {
      estadosOcultarDocumento: [1, 5, 6, '1', '5', '6'],
      loading: true,
      dnt: null,
      dte: null,
    };
  },
  async created() {
    const params = {
      febosId: `${this.$route.params.febosId}`,
    };
    await this.checkQrApprovals(params);
    this.dnt = this.approvalDetails?.dnt;
    this.dte = this.approvalDetails?.dte;
    this.loading = false;
  },
  methods: {
    ...mapActions('VerificarQrAprobaciones', ['checkQrApprovals']),
    formatNumber(amount) {
      if (amount) {
        const parts = amount.toString().split('.');
        if (parts.length > 1) {
          const num = `0${parts[1]}`;
          if (num * 1 > 0) {
            return `${parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${parts[1]}`;
          }
          return parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      return '';
    },
  },
  computed: {
    ...mapGetters('VerificarQrAprobaciones', ['approvalDetails']),
    approvalsMustBeShown() {
      if (
        this.approvalDetails
        && this.approvalDetails.ejecucion
        && this.isConventionIut(this.approvalDetails.ejecucion.iut)
      ) {
        return false;
      }
      return this.approvalDetails && this.approvalDetails.aprobaciones;
    }

  }
};
</script>

<style lang="scss">
.febos-main-logo{
  width: 400px;
  margin-bottom: 40px;
}

@media (max-width: 766px) {
  .febos-main-logo{
    width: 200px;
  }
}

.field {
  min-width: 150px;
  font-weight: bold;
}

.values {
  font-weight: 100;
  font-size: 105%;
}

.card-body {
  padding-left: 150px;
  padding-right: 150px;
  padding-top: 35px;
  @media only screen and (max-width: 900px) {
    padding: 20px;
  }
}

.numero {
  font-size: 250%;
  float: left;
  margin-right: 10px;
}

.persona {
  border: gray 1px dashed !important;
  display: inline-block;
  padding: 6px;
  border-radius: 10px;
  margin-right: 6px;
}

.nombre {
  font-size: 110%;
  font-weight: bold;
}

.aprobaciones {
  border-bottom: dashed 1px #ccc;
  margin-bottom: 20px;
}
</style>
